import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom";
import { OrderSummaryRowSkeleton } from "./OrderSummaryRowSkeleton";
import { ShipMethodSkeleton } from "./shipMethodSkeleton";

export const CheckoutSkeleton = () => {
  return (
    <section className="checkout-section">
      <div className="container-fluid container-lg">
        <div className="row row-equal">
          <div className="col-md-7 col-lg-7 checkout-left">
            <div className="row">
              <div className="col-lg-12 checkout-lft-title">
                <div className="wesproduct-title cart-title">
                  <h1>Order Checkout</h1>
                  <Link to="/OrderDetails" className="return-link">
                    <i className="fa-solid fa-chevron-left" /> Return to Cart
                  </Link>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="delivery-method">
                  <h3>
                    <Skeleton width={180} height={25} />
                  </h3>
                  <ShipMethodSkeleton />
                  <div className="selected-shipping-address">
                    <h3>
                      <Skeleton width={180} height={25} />
                    </h3>
                    <div className="shipp-to">
                      <div className="row">
                        <div className="col-sm-9 col-lg-9">
                          <Skeleton width="50%" height={15} />
                          <Skeleton width="60%" height={15} />
                          <Skeleton width="40%" height={15} />
                          <Skeleton width="35%" height={15} />
                          <Skeleton width="30%" height={15} />
                          <Skeleton width="00%" height={0} />
                          <Skeleton width="40%" height={15} />
                        </div>
                        <div className="col-sm-3 col-lg-3">
                          <Skeleton width={100} height={15} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="selected-shipping-method">
                    <h3>
                      <Skeleton width={180} height={25} />
                    </h3>
                    <div className="shipping-method-list">
                      <Skeleton width="100%" height={60} />
                    </div>
                  </div>
                  <div className="checkout-button">
                    <Skeleton width={120} height={40} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Section */}
          <div className="col-md-5 col-lg-5 rht-summary">
            <div className="checkout-orderSummary">
              <div className="wesproduct-title checkout-title">
                <h3>Order Summary</h3>
              </div>
              <OrderSummaryRowSkeleton />

              <div className="order-summary-total">
                <div className="orderSummary-list">
                  <div className="order-summary-list">
                    <p>
                      <Skeleton width={100} height={15} />
                    </p>
                    <span>
                      <Skeleton width={80} height={15} />
                    </span>
                  </div>
                  <div className="order-summary-list">
                    <p>
                      <Skeleton width={80} height={15} />
                    </p>
                    <span>
                      <Skeleton width={40} height={15} />
                    </span>
                  </div>
                  <div className="order-summary-list">
                    <p>
                      <Skeleton width={80} height={15} />
                    </p>
                    <span>
                      <Skeleton width={40} height={15} />
                    </span>
                  </div>
                  <div className="order-summary-list">
                    <p>
                      <Skeleton width={80} height={15} />
                    </p>
                    <span>
                      <Skeleton width={80} height={15} />
                    </span>
                  </div>
                </div>
                <div className="orderSummary-total">
                  <div className="order-summary-list">
                    <p>
                      <Skeleton width={150} height={25} />
                    </p>
                    <span>
                      <Skeleton width={80} height={25} />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
